import React from 'react';

const ModerationDashboard: React.FC = () => {
  return (
    <div>
      <h1>Moderation Dashboard</h1>
      <p>Coming soon...</p>
    </div>
  );
};

export default ModerationDashboard;
